/**
 * The app half of add_grocery_items' receipt — issue #1586.
 *
 * ⚠️ `groceryReceiptLine` must produce the SAME sentence as the server's copy in
 * supabase/functions/kin-chat/groceryAdd.ts, which is handed to the model as the
 * reply to use. A parity test pins the two, because a toast that says one thing
 * under a chat bubble that says another reads as two different features.
 *
 * Duplicated rather than imported: nothing in `src/` imports Edge Function code
 * into the app bundle, same arrangement as src/lib/mealTypes.ts.
 */

function joinNames(names: string[]): string {
  if (names.length <= 1) return names[0] ?? "";
  if (names.length === 2) return `${names[0]} and ${names[1]}`;
  return `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
}

export function groceryReceiptLine(added: string[], alreadyOn: string[]): string {
  if (added.length === 0 && alreadyOn.length === 0) return "";
  if (added.length === 0) return `Already on your grocery list: ${joinNames(alreadyOn)} 💜`;
  const addedPart = `Done, added ${joinNames(added)} to your grocery list`;
  if (alreadyOn.length === 0) return `${addedPart} 💜`;
  return `${addedPart}. Already there: ${joinNames(alreadyOn)} 💜`;
}

/**
 * What Undo has to do: delete the lines this add inserted, and put back the
 * check mark on lines it only un-checked. Deleting a restored line would take
 * away something she already had on her list.
 */
export function groceryUndoPlan(added: Array<{ id: string; restored: boolean }>): {
  deleteIds: string[];
  recheckIds: string[];
} {
  return {
    deleteIds: added.filter((a) => !a.restored).map((a) => a.id),
    recheckIds: added.filter((a) => a.restored).map((a) => a.id),
  };
}
